import { render, staticRenderFns } from "./AppliedJobCard.vue?vue&type=template&id=b52671ae&"
import script from "./AppliedJobCard.vue?vue&type=script&lang=js&"
export * from "./AppliedJobCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports